// Generated by LiveScript 1.6.0
var ref$, id, log, max, delay, findInside, isMenu, isItem, clear, Templates, Modal, MenuView, out$ = typeof exports != 'undefined' && exports || this;
ref$ = require('utils'), id = ref$.id, log = ref$.log, max = ref$.max, delay = ref$.delay, findInside = ref$.findInside;
ref$ = require('./functions'), isMenu = ref$.isMenu, isItem = ref$.isItem;
clear = function(){
  return $(this._targets[0]).html('');
};
Templates = require('./templates');
Modal = {
  $host: $('body'),
  $current: $(),
  init: function(){
    return Modal.$host.on('click', bind$(Modal, 'hide'));
  },
  show: function(content){
    var html;
    html = "<div class=\"modal\">\n  <div class=\"modal-overlay\"></div>\n  <div class=\"modal-content\">" + content + "</div>\n</div>";
    log('%cModal::show', 'color:blue');
    Modal.hide();
    Modal.$current = $(html);
    Modal.$host.append(Modal.$current);
    return delay(0, function(){
      return Modal.$current.addClass('reveal');
    });
  },
  hide: function(){
    var $current;
    $current = Modal.$current;
    $current.removeClass('reveal');
    return delay(300, function(){
      return $current.remove();
    });
  }
};
out$.MenuView = MenuView = (function(){
  MenuView.displayName = 'MenuView';
  var spinOpts, prototype = MenuView.prototype, constructor = MenuView;
  spinOpts = {
    lines: 10,
    length: 9,
    width: 3,
    radius: 11,
    corners: 1,
    speed: 1,
    shadow: false
  };
  function MenuView(host, menuId){
    var $$, this$ = this;
    this.host = host;
    this.menuId = menuId;
    this.setCorrectSize = bind$(this, 'setCorrectSize', prototype);
    $$ = findInside(this.host);
    this.dom = {
      back: $$('.go-back'),
      side: $$('.servd-sidebar'),
      main: $$('.servd-main'),
      menus: $$('.menus'),
      items: $$('.items')
    };
    this.dom.back.on('click', function(){
      this$.moveSidebar(false);
      return this$.setCorrectSize(true);
    });
    this.spinner = new Spinner(spinOpts);
    this.standalone = !!this.host.data('standalone');
    this.callbacks = {
      height: id
    };
    $(window).on('resize', function(){
      if ($(window).width() > 700) {
        return this$.resetSidebar();
      }
    });
    Modal.init();
  }
  MenuView.prototype.render = function(data){
    this.dom.side.prepend(Templates.sidebar(data, this.menuId));
    return this.dom.menus.html(Templates.main(data, this.menuId));
  };
  MenuView.prototype.renderItem = function(node, chain, servd){
    var $item;
    $item = $(Templates.item(node, chain, servd, this.menuId));
    return this.dom.items.html('').append($item);
  };
  MenuView.prototype.selectMenuPaneByChain = function(chain){
    return this.dom.menus.children().filter(byChain(chain));
  };
  MenuView.prototype.harvestData = function($parent, ix){
    return $parent.find('ul').children().eq(ix).data();
  };
  MenuView.prototype.showItemsPanel = function(){
    TweenLite.to(this.dom.menus, 0.4, {
      x: -760
    });
    return TweenLite.to(this.dom.items, 0.4, {
      left: 0
    });
  };
  MenuView.prototype.hideItemsPanel = function(){
    TweenLite.to(this.dom.menus, 0.4, {
      x: 0
    });
    return TweenLite.to(this.dom.items, 0.4, {
      left: '100%',
      onComplete: clear
    });
  };
  MenuView.prototype.deselectMenus = function(){
    return this.dom.menus.find('.active').removeClass('active');
  };
  MenuView.prototype.deselectSidebar = function(){
    return this.dom.side.find('.active').removeClass('active');
  };
  MenuView.prototype.selectSidebarSection = function(ixChain){
    var $selection, i$, len$, i, ix, $target, results$ = [];
    $selection = this.dom.side.children();
    for (i$ = 0, len$ = ixChain.length; i$ < len$; ++i$) {
      i = i$;
      ix = ixChain[i$];
      $target = $selection.eq(ix);
      $target.addClass('active');
      results$.push($selection = $target.children('ul').children());
    }
    return results$;
  };
  MenuView.prototype.selectMenuSection = function(ixChain){
    var target, ƒId, $target;
    target = this.menuId + '-' + ixChain.join('-');
    ƒId = function(){
      return target === String($(this).data('id'));
    };
    $target = this.dom.menus.children().filter(ƒId);
    return $target.addClass('active');
  };
  MenuView.prototype.setSidebarState = function(ixChain){
    this.deselectSidebar();
    return this.selectSidebarSection(ixChain);
  };
  MenuView.prototype.setMenuState = function(ixChain){
    this.deselectMenus();
    return this.selectMenuSection(ixChain);
  };
  MenuView.prototype.showItemPopup = function(node, chain, servd){
    if (node.id == null) {
      return;
    }
    return Modal.show(Templates.popup(node, chain, servd));
  };
  MenuView.prototype.dismissPopup = function(){
    return Modal.hide();
  };
  MenuView.prototype.resetSidebar = function(){
    if ($(window).width() > 960) {
      return TweenLite.set({
        x: -130
      });
    } else {
      return TweenLite.set({
        x: 0
      });
    }
  };
  MenuView.prototype.moveSidebar = function(dir){
    return this.host.toggleClass('move-sidebar', dir);
  };
  MenuView.prototype.setCorrectSize = function(){
    var sidebarHeight, currentMenuHeight, h;
    sidebarHeight = this.dom.side.outerHeight() + 30;
    currentMenuHeight = this.dom.main.find('.menus .active').first().outerHeight() || 0;
    h = max(sidebarHeight, currentMenuHeight);
    this.callbacks.height(h);
    return TweenLite.to(this.host, 0.3, {
      height: h
    });
  };
  MenuView.prototype.showBusyState = function(){
    return this.spinner.spin(this.host[0]);
  };
  MenuView.prototype.hideBusyState = function(){
    return this.spinner.stop();
  };
  MenuView.prototype.onHeightChange = function(λ){
    return this.callbacks.height = λ;
  };
  MenuView.prototype.pokeHeight = function(){
    return this.setCorrectSize();
  };
  return MenuView;
}());
function bind$(obj, key, target){
  return function(){ return (target || obj)[key].apply(obj, arguments) };
}
//# sourceMappingURL=data:application/json;base64,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

